import React from "react";

/**
 * skeleton for the message column while history is loading — avoids an empty white panel flash.
 */
export function ChatMessagesSkeleton() {
  return (
    <div className="flex-1 overflow-hidden p-4 space-y-3 max-[700px]:p-3 bg-paper">
      {[0, 1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className={`flex animate-pulse ${i % 2 === 0 ? "justify-start" : "justify-end"}`}
        >
          <div
            className="h-12 max-w-[70%] rounded-sm border-2 border-ink/20 bg-ink/5"
            style={{
              width: `${45 + ((i * 17) % 35)}%`,
            }}
          />
        </div>
      ))}
    </div>
  );
}
